<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row no-gutters>
          <h4>{{ signature.name }}</h4>
          <v-spacer></v-spacer>
          <v-tooltip top z-index="1000">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" icon :color="color">{{ icon }}</v-icon>
            </template>
            <span>{{ validText }}</span>
          </v-tooltip>

          <span class="ml-2">{{ signature.date }}</span>
        </v-row>
        <v-row no-gutters>
          <span>{{ signature.entity }}</span>
        </v-row>
      </v-col>
    </v-row>
    <v-divider class="my-2"></v-divider>
  </div>
</template>
<script>
export default {
    props: {
        signature: {
            type: Object,
        },
    },
    computed: {
        icon() {
            return this.signature.isValid ? 'mdi-check' : 'mdi-close';
        },
        validText() {
            return this.signature.isValid ? this.$t('Valid') : this.$t('NotValid');
        },
        color() {
            return this.signature.isValid ? 'success' : 'red';
        },
    },
};
</script>